/* One Final Bite: smoothness fixes (Oct 2026).
   - Native scrolling: the smooth-scroll library was removed from theme.liquid because it delayed every scroll.
   - On-page links (#flavors, #box...) still glide smoothly using the browser's own smooth scroll.
   - The endless slow spins on cookie photos are stopped; they repainted the page on every frame.
   - "Add" buttons (Oct 17): open the cart drawer after adding so shoppers see it worked, and never
     show "Something went wrong" when the cookie actually made it into the cart. */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href');
    if (!id || id.length < 2) return;
    var target = null;
    try { target = document.querySelector(id); } catch (err) { return; }
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- Add to cart (replaces the handler in ofb.js) ---------- */
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var toastEl;
  function toast(html) {
    if (!toastEl) {
      toastEl = document.querySelector('.ofb-toast') || document.createElement('div');
      toastEl.className = 'ofb-toast';
      toastEl.setAttribute('role', 'status');
      if (!toastEl.parentNode) document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }
  function numericId(id) {
    var m = String(id).match(/(\d+)\s*$/);
    return m ? Number(m[1]) : NaN;
  }
  function qtyInCart(id) {
    var n = numericId(id);
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        return (c.items || []).reduce(function (sum, it) {
          return it.variant_id === n && !(it.properties && it.properties._box) ? sum + it.quantity : sum;
        }, 0);
      })
      .catch(function () { return -1; });
  }
  function openCart(name) {
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      setTimeout(function () { if (!drawer.isOpen) drawer.open(); }, 250);
    } else {
      toast(name + ' added. <a href="' + root + 'cart">View cart</a>');
    }
  }
  function addToCart(btn) {
    var id = btn.getAttribute('data-variant-id');
    var name = btn.getAttribute('data-name') || 'Cookie';
    if (!id || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    qtyInCart(id).then(function (before) { run(btn, id, name, before); });
  }
  function run(btn, id, name, before) {
    var finish = function (ok) {
      btn.removeAttribute('aria-busy');
      if (!ok) {
        toast('Couldn\'t add ' + name + '. Try again or <a href="' + root + 'cart">open your cart</a>.');
        return;
      }
      btn.classList.add('is-added');
      var label = btn.querySelector('.ofb-add__label');
      var prev = label ? label.textContent : '';
      if (label) label.textContent = 'Added';
      setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = prev; }, 1600);
      openCart(name);
    };
    /* If anything looks like a failure, check the cart itself before telling the shopper. */
    var added = function () {
      return qtyInCart(id).then(function (now) { return before >= 0 && now > before; });
    };
    var verify = function () { added().then(function (ok) { finish(ok); }); };
    var plainAdd = function () {
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: numericId(id), quantity: 1 }] })
      }).then(function (r) {
        if (r.ok) {
          finish(true);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } else verify();
      }).catch(verify);
    };
    var actions = window.Shopify && window.Shopify.actions;
    if (actions && actions.updateCart) {
      actions.updateCart({ lines: [{ merchandiseId: id, quantity: 1 }] }, { event: { context: 'product' } })
        .then(function (res) {
          var errs = res && res.userErrors && res.userErrors.length;
          if (errs) verify(); else finish(true);
        })
        .catch(function () {
          /* updateCart may have succeeded before throwing; only add again if the cookie isn't there. */
          added().then(function (ok) { if (ok) finish(true); else plainAdd(); });
        });
    } else {
      plainAdd();
    }
  }
  /* Capture phase runs before ofb.js's handler; stopping here keeps ofb.js from adding a second time. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ofb-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn);
  }, true);

  var gsap = window.gsap;
  if (!gsap) return;
  document.querySelectorAll('.ofb-stage__cookie img, .ofb-lp-collage__item img').forEach(function (img) {
    gsap.killTweensOf(img);
    gsap.set(img, { clearProps: 'transform' });
  });
})();
